import { z } from 'zod'

/** Represents the enum public.change_log_obj_type_ */
enum ChangeLogObjType {
  CABLE = 'CABLE',
  CABLE_EVENT = 'CABLE_EVENT',
  CABLE_HISTORY = 'CABLE_HISTORY',
  CABLE_LEAD_SECTION = 'CABLE_LEAD_SECTION',
  CABLE_BODY_SECTION = 'CABLE_BODY_SECTION',
  CABLE_EEPROM = 'CABLE_EEPROM',
  CABLE_PRICE = 'CABLE_PRICE',
  LOGGER = 'LOGGER',
  LOGGER_EVENT = 'LOGGER_EVENT',
  LOGGER_HISTORY = 'LOGGER_HISTORY',
  MODEM = 'MODEM',
  MODEM_HISTORY = 'MODEM_HISTORY',
  ORGANIZATION = 'ORGANIZATION',
  PROJECT = 'PROJECT',
  PROJECT_ALIAS = 'PROJECT_ALIAS',
  PROJECT_SITE = 'PROJECT_SITE',
  PROJECT_USERS = 'PROJECT_USERS',
  SITE = 'SITE',
  SITE_CABLE_HISTORY = 'SITE_CABLE_HISTORY',
  SITE_CABLE_HISTORY_LABELS = 'SITE_CABLE_HISTORY_LABELS',
  SITE_LABELS = 'SITE_LABELS',
  SITE_MODEM_HISTORY = 'SITE_MODEM_HISTORY',
  SITE_MODEM_HISTORY_LABELS = 'SITE_MODEM_HISTORY_LABELS',
  SITE_LOGGER_HISTORY = 'SITE_LOGGER_HISTORY',
  USER = 'USER',
  USER_AUTH = 'USER_AUTH',
  ORGANIZATION_PROJECT = 'ORGANIZATION_PROJECT',
  ROLE = 'ROLE',
  FEE_STRUCTURE = 'FEE_STRUCTURE',
  FEES = 'FEES',
  ASSESSED_FEES = 'ASSESSED_FEES',
  ASSESSED_OVERAGE_FEES = 'ASSESSED_OVERAGE_FEES',
  ASSESSED_LATE_FEES = 'ASSESSED_LATE_FEES',
  MAXIO_LOGGER_SUBSCRIPTION = 'MAXIO_LOGGER_SUBSCRIPTION',
  MAXIO_SUBSCRIPTION_NOTE = 'MAXIO_SUBSCRIPTION_NOTE',
  ORDER = 'ORDER',
  ORDER_LINE_ITEM = 'ORDER_LINE_ITEM',
  SERVICE_CONTRACT = 'SERVICE_CONTRACT',
  SERVICE_CONTRACT_ITEM = 'SERVICE_CONTRACT_ITEM',
  PRODUCT_SERVICE = 'PRODUCT_SERVICE',
  PRODUCT_SERVICE_PRICE_HISTORY = 'PRODUCT_SERVICE_PRICE_HISTORY',
  SERVICE_CONTRACT_PAYMENT = 'SERVICE_CONTRACT_PAYMENT',
  LOGGER_ACTIVATION = 'LOGGER_ACTIVATION',
  NOTE = 'NOTE',
  REPORT_TEMPLATE = 'REPORT_TEMPLATE',
  REPORT_CONFIGURATION = 'REPORT_CONFIGURATION',
  REPORT_INSTANCE = 'REPORT_INSTANCE',
  SENSOR_CALIBRATION = 'SENSOR_CALIBRATION',
  BOM_CONFIG_VERSION = 'BOM_CONFIG_VERSION',
  BOM_PART = 'BOM_PART',
  BOM_ROUTING = 'BOM_ROUTING',
  BOM_MAPPING = 'BOM_MAPPING',
  BOM_CONDUIT_TRANSITION = 'BOM_CONDUIT_TRANSITION',
  INGESTION = 'INGESTION',
  LANDING_PAGE_CONTENT = 'LANDING_PAGE_CONTENT',
  CMS_PAGE = 'CMS_PAGE',
  WEBHOOK_EVENT = 'WEBHOOK_EVENT',
  CABLE_LOCK_EVENT = 'CABLE_LOCK_EVENT',
}

export default ChangeLogObjType

/** Zod schema for change_log_obj_type_ */
export const changeLogObjType = z.enum([
  'CABLE',
  'CABLE_EVENT',
  'CABLE_HISTORY',
  'CABLE_LEAD_SECTION',
  'CABLE_BODY_SECTION',
  'CABLE_EEPROM',
  'CABLE_PRICE',
  'LOGGER',
  'LOGGER_EVENT',
  'LOGGER_HISTORY',
  'MODEM',
  'MODEM_HISTORY',
  'ORGANIZATION',
  'PROJECT',
  'PROJECT_ALIAS',
  'PROJECT_SITE',
  'PROJECT_USERS',
  'SITE',
  'SITE_CABLE_HISTORY',
  'SITE_CABLE_HISTORY_LABELS',
  'SITE_LABELS',
  'SITE_MODEM_HISTORY',
  'SITE_MODEM_HISTORY_LABELS',
  'SITE_LOGGER_HISTORY',
  'USER',
  'USER_AUTH',
  'ORGANIZATION_PROJECT',
  'ROLE',
  'FEE_STRUCTURE',
  'FEES',
  'ASSESSED_FEES',
  'ASSESSED_OVERAGE_FEES',
  'ASSESSED_LATE_FEES',
  'MAXIO_LOGGER_SUBSCRIPTION',
  'MAXIO_SUBSCRIPTION_NOTE',
  'ORDER',
  'ORDER_LINE_ITEM',
  'SERVICE_CONTRACT',
  'SERVICE_CONTRACT_ITEM',
  'PRODUCT_SERVICE',
  'PRODUCT_SERVICE_PRICE_HISTORY',
  'SERVICE_CONTRACT_PAYMENT',
  'LOGGER_ACTIVATION',
  'NOTE',
  'REPORT_TEMPLATE',
  'REPORT_CONFIGURATION',
  'REPORT_INSTANCE',
  'SENSOR_CALIBRATION',
  'BOM_CONFIG_VERSION',
  'BOM_PART',
  'BOM_ROUTING',
  'BOM_MAPPING',
  'BOM_CONDUIT_TRANSITION',
  'INGESTION',
  'LANDING_PAGE_CONTENT',
  'CMS_PAGE',
  'WEBHOOK_EVENT',
  'CABLE_LOCK_EVENT',
])
